// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1fpYH","content":"LoadingAlert_content__1OCsX"};